import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

// Revoke an app's authorization to act as a service account. Removing the
// binding stops the app obtaining NEW credentials, but the resource server and
// the refresh path only re-check oauthGrant.revokedAt (not the binding), so a
// grant the app already holds keeps working — including refresh — until it is
// revoked. So deauthorize also cascade-revokes the live grants for this
// (app, account) pair, giving the same immediate cutoff as deleting the app
// (which cascades grants via FK).
export const deauthorizeOAuthAppForServiceAccount = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {
    binding: {
      kind: "oauthClientServiceAccount",
      from: "id",
    },
  },
  permissions: [
    {
      permission: "service_account:manage",
      scopeId: ({ args }) => args.binding.serviceAccountId,
    },
  ],
  fn: async ({ tx, args: { binding } }) => {
    await tx.mutate.oauthClientServiceAccount.delete({ id: binding.id });

    // Revoke only the live grants for this exact (app, account) pair — never
    // other accounts' grants, nor user-bound (non-SA) grants.
    const liveGrants = await tx.run(
      zql.oauthGrant
        .where("clientId", binding.clientId)
        .where("serviceAccountId", binding.serviceAccountId)
        .where("revokedAt", "IS", null)
    );
    const now = Date.now();
    for (const grant of liveGrants) {
      await tx.mutate.oauthGrant.update({ id: grant.id, revokedAt: now });
    }
  },
});
